export type AcceptedFileType = "CSV" | "EXCEL" | "TEXT" | "JPG" | "PNG" | "PDF";

export function getMimeTypes(fileTypes: AcceptedFileType[]) {
  return [...new Set(fileTypes)].flatMap((type) => {
    switch (type) {
      case "CSV":
        return ["text/csv"];
      case "EXCEL":
        return [
          "application/vnd.ms-excel",
          "application/vnd.ms-excel.sheet.macroEnabled.12",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ];
      case "TEXT":
        return ["text/plain"];
      case "JPG":
        return ["image/jpeg"];
      case "PNG":
        return ["image/png"];
      case "PDF":
        return ["application/pdf"];
      default:
        return [];
    }
  });
}
